import { render, staticRenderFns } from "./XcertificateManager.vue?vue&type=template&id=7f4729ea"
import script from "./XcertificateManager.vue?vue&type=script&lang=js"
export * from "./XcertificateManager.vue?vue&type=script&lang=js"
import style0 from "./XcertificateManager.vue?vue&type=style&index=0&id=7f4729ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports